module.exports = __webpack_public_path__ + "static/img/B_Corp2.f459778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/B_Corp2.jpg
// module id = gUrh
// module chunks = 1